import Icon from '../../Nodes/Icon'

const editButton = (props) => {
    return (
        <a className="edit-button" 
           href={props.href} 
           target="_blank" rel="noreferrer">
            Edit <Icon>edit</Icon>
        </a>
    )
}

export default editButton